import React from "react";
import {
    AutoAwesomeOutlined,
    CallMergeOutlined,
    EventRepeatOutlined,
    PaidOutlined,
    TrendingDownOutlined,
    TuneOutlined,
} from "@mui/icons-material";

/**
 * One glyph per opportunity type. This replaces the supplier monogram on the
 * card: the supplier is already named in the headline or the applies-to line,
 * whereas the type is new information and makes the deck scannable.
 */
const ICONS: Record<string, React.ElementType> = {
    contract_window: EventRepeatOutlined,
    payment_terms: PaidOutlined,
    off_contract_leakage: TrendingDownOutlined,
    supplier_fragmentation: CallMergeOutlined,
    demand_rightsizing: TuneOutlined,
};

export const OpportunityTypeIcon: React.FC<{moveType: string, className?: string}> = ({moveType, className}) => {
    const Icon = ICONS[moveType] ?? AutoAwesomeOutlined;
    return <Icon className={className} aria-hidden="true"/>;
};
